import React, { useEffect, useState, useRef } from 'react'

import { makeStyles } from '@material-ui/core/styles';
import axios from "@fuse/utils/axios";
import { getLocalTimeFromUTC } from '@fuse/utils/dateOperations'
import Tooltip from '@material-ui/core/Tooltip';

import { AgGridReact } from 'ag-grid-react';
import '../../../../../../styles/ag-custom.css';
import CustomFilter from '@fuse/components/AgGridFilterGroupView/components/CustomFilter';
import { separateArabicAndNumber } from '@fuse/utils/currencyFormat';

import { withRouter } from 'react-router-dom';
import FuseLoading from '@fuse/core/FuseLoading';

const useStyles = makeStyles({

    root: {
        // '& .MuiDataGrid-root-1911 .MuiDataGrid-footer':{
        //   border: '2px solid black',
        //   display: 'none !important'
        // }
        '& .MuiDataGrid-columnsContainer': {
            background: '#8f8f8f26'
        }
    }
});

const action_to_color = {
    "CREATED": "green",
    "UPDATED": "orange",
    "ARCHIVED": "red",
    "RESTORED": "blue"
}

function FilesTab({ assetDetails }) {
    const classes = useStyles();
    const [activities, setActivities] = useState(null)

    const [windowHeight, setWindowHeight] = useState(window.innerHeight - 430);

    const gridRef = useRef()
    const onGridReady = params => {
        // Following line to make the currently visible columns fit the screen  
        params.api.sizeColumnsToFit();

        // Following line dymanic set height to row on content
        params.api.resetRowHeights();
    };


    const columns = [
        { field: 'action_id', headerName: 'ID', minWidth: 100, headerComponent: (props) => (CustomFilter(props, '', gridRef)) },
        {
            field: 'action_date_and_time', headerName: 'Action date and time', minWidth: 250, headerComponent: (props) => (CustomFilter(props, '', gridRef)), cellRenderer: (params) =>
                !params.value ? '' : getLocalTimeFromUTC(params.value),
        },
        {
            field: 'action', headerName: 'Action', minWidth: 150, headerComponent: (props) => (CustomFilter(props, '', gridRef)),
            cellRenderer: (params) => {
                return (<span style={{ color: action_to_color[params.value], fontWeight: 'bold' }}>{params.value}</span>)
            }
        },
        { field: 'field_name', headerName: 'Field Name', minWidth: 200, headerComponent: (props) => (CustomFilter(props, '', gridRef)) },
        {
            field: 'previous_value', headerName: 'Previous value', minWidth: 200, headerComponent: (props) => (CustomFilter(props, '', gridRef)),
            cellRenderer: (params) => {
                // return Boolean(params.value) ? params.value : 'N/A'
                if (typeof params.value !== 'object') {
                    if (params.value?.length > 20) {
                        return (
                            <Tooltip title={params.value} placement="top-start">
                                {typeof params.value !== 'object' &&
                                    <span style={{ cursor: 'pointer' }}>{`${params.value?.slice(0, 21)}...`}</span>
                                }
                            </Tooltip>
                        )
                    }
                    return (<span>{params.value ? params.value : 'N/A'}</span>)

                }
                if (params.value?.number.length > 14) {
                    return (
                        <Tooltip title={`\u202A${params.value?.word} ` + `\u202C${params.value?.number}`} placement="top-start">
                            <span style={{ cursor: 'pointer' }}>
                                {`\u202A${params.value?.word} ` + `\u202C` + `${params.value?.number?.slice(0, 14)}` + `...`}
                            </span>
                        </Tooltip>
                    )
                }
                return (<span dir="rtl">{`\u202A${params.value?.word} ` + `\u202C${params.value?.number}`}</span>)



            },
        },
        {
            field: 'current_value', headerName: 'Current value', minWidth: 200, headerComponent: (props) => (CustomFilter(props, '', gridRef)),
            cellRenderer: (params) => {
                // return Boolean(params.value) ? params.value : 'N/A'
                if (typeof params.value !== 'object') {
                    if (params.value?.length > 20) {
                        return (
                            <Tooltip title={params.value} placement="top-start">
                                {typeof params.value !== 'object' &&
                                    <span style={{ cursor: 'pointer' }}>{`${params.value?.slice(0, 21)}...`}</span>
                                }
                            </Tooltip>
                        )
                    }
                    return (<span>{params.value ? params.value : 'N/A'}</span>)

                }
                if (params.value?.number.length > 14) {
                    return (
                        <Tooltip title={`\u202A${params.value?.word} ` + `\u202C${params.value?.number}`} placement="top-start">
                            <span style={{ cursor: 'pointer' }}>
                                {`\u202A${params.value?.word} ` + `\u202C` + `${params.value?.number?.slice(0, 14)}` + `...`}
                            </span>
                        </Tooltip>
                    )
                }
                return (<span dir="rtl">{`\u202A${params.value?.word} ` + `\u202C${params.value?.number}`}</span>)



            },
        },
        { field: 'name', headerName: 'Name', minWidth: 200, headerComponent: (props) => (CustomFilter(props, '', gridRef)) },
        { field: 'user_role', headerName: 'Role', minWidth: 200, headerComponent: (props) => (CustomFilter(props, '', gridRef)) },
        {
            field: 'description', headerName: 'Description', minWidth: 400, headerComponent: (props) => (CustomFilter(props, '', gridRef)),
            cellRenderer: (params) => {
                if (params.value?.length > 50) {
                    return (
                        <Tooltip title={params.value} placement="top-start">
                            <span className='activitiesTab-descText'>{params.value}</span>
                        </Tooltip>
                    )
                }
                return (<span>{params.value}</span>)

            }
        }

    ];

    function formatActivities(data) {
        return data.map((item) => {
            return {
                id: item.id,
                action_id: `act${item.id}`,
                action_date_and_time: item.created_at,
                name: item.user_name,
                action: item.action_name,
                description: item.comment,
                previous_value: item.action_field_name === 'Purchase Cost' ? separateArabicAndNumber(item.previous_data) : item.previous_data,
                current_value: item.action_field_name === 'Purchase Cost' ? separateArabicAndNumber(item.current_data) : item.current_data,
                user_role: item.user_role_name,
                field_name: item.action_field_name
            }
        })
    }

    useEffect(() => {
        if (!assetDetails) return

        axios.get(`/assets/fetch-asset-activities/${assetDetails.id}`).then((res) => {
            // console.log('res',res);
            setActivities(formatActivities(res.data.data.activities))
        }).catch((err) => {
            console.log('error', err);
        })
    }, [assetDetails])

    return (
        <>
            <div
                className="ag-theme-alpine"
                style={{
                    width: "100%",
                    height: windowHeight + 105,
                    fontSize: '12px'
                }}
            >
                {activities === null ? (
                    <FuseLoading />
                ) : (
                    <AgGridReact
                            ref={gridRef}
                            theme='legacy'
                        rowData={activities}
                        animateRows
                        onGridReady={onGridReady}
                        paginationPageSize={10}
                            paginationPageSizeSelector={[10, 20, 50, 100]}
                        rowHeight={30}
                        headerHeight={44}
                        pagination
                        defaultColDef={{
                            resizable: true,
                            flex: 1,
                            sortable: false,
                            filter: 'agTextColumnFilter',
                            wrapText: true,
                        }}
                        columnDefs={columns}
                    />
                )}
            </div>
            {/* <div className={classes.root} style={{ height: 290, width: '100%',overflow:"auto" }}>
                <DataGrid
                    rows={activities}
                    columns={columns}
                    hideFooter={true}
                />
            </div> */}
        </>
    )
}

export default withRouter(FilesTab)
